export default __webpack_public_path__ + "static/media/happy_planning.0d904230.png";